import request from 'superagent'

// Extract only body from response, when other stuff like response
// headers and so on are useless
const extractBody = ({ body }) => body

export const getJsonData = (filename) =>
  request.get(filename)
    .then(extractBody)



// WEBPACK FOOTER //
// ./src/api/index.js